export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/pianissimo-icon.svg?d137bed9a64f5d016235251e760c9298";